import * as React from 'react';
import { Link } from 'react-router-dom';
import { MUIDataTableColumnDef } from 'mui-datatables';
import { formatMonitoringDeliveryDate, MonitoringPage } from './MonitoringPage';

const columns: MUIDataTableColumnDef[] = [
  {
    name: 'orderNumber',
    label: 'Order',
    options: {
      customBodyRender: (value: string) => (
        <Link to={`/view-order/${value}`} target="_blank">
          {value}
        </Link>
      ),
    },
  },
  { name: 'deliveryDate', label: 'Delivery Date', options: { customBodyRender: formatMonitoringDeliveryDate } },
  { name: 'poNumber', label: 'PO Number' },
  { name: 'productCode', label: 'Product Code' },
  { name: 'issue', label: 'Issue' },
];

export const PurchaseOrdersMonitor = () => (
  <MonitoringPage
    apiPath="/api/monitoring/purchase-orders"
    allowTba
    columns={columns}
    emptyMessage="No purchase order discrepancies found."
    title="Purchase Orders Monitor"
  />
);
